/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select } from 'antd';

const RemoveColumnForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item
            label="Columns to Remove (select multiple)"
            name="columns"
            rules={[{ required: true, type: 'array', min: 1, message: 'Select at least one column' }]}
            help="Hold Ctrl/Cmd to select multiple columns"
        >
            <Select
                mode="multiple"
                placeholder="Select columns to remove"
                options={columns.map(c => ({ label: c, value: c }))}
            />
        </Form.Item>
    </Form>
);

export default RemoveColumnForm;
